import { Component, Directive, ElementRef, Injector, Input, Optional, ViewContainerRef } from "@angular/core";
import { ListComponent } from "./list.component";
import { BaseComponent, register, propFactory as PropertiesFactory } from '@wm/components-base';

const WIDGET_CONFIG = { widgetType: 'wm-listtemplate'};

@Component({
  selector: '[wmListItem]',
  template: `<ng-content></ng-content>`,
  exportAs: 'listItemRef',
  standalone: true
})
export class ListItemDirective extends BaseComponent {
  static initializeProps = register('wm-listtemplate');

  private viewContainerRef: ViewContainerRef;
  private listComponent: ListComponent;
  public item: any;

  private itemClass = '';
  private _currentItemWidgets = {};

  @Input() set wmListItem(val: any) {
    this.item = val;
  }

  constructor(inj: Injector, elRef: ElementRef, @Optional() public _viewParent: ListComponent) {
    _viewParent.setWidgetId(elRef.nativeElement);
    super(inj, WIDGET_CONFIG);
    this.viewContainerRef = inj.get(ViewContainerRef);
    this.listComponent = _viewParent;
  }
}
